/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".preview-template-v1-container .mat-dialog-container{overflow:hidden;padding:15px 24px}.preview-template-v1-wrapper__title{font-weight:600;margin:12px 0}.preview-template-v1-wrapper__content{margin:20px 0}.preview-template-v1-wrapper__actions{display:flex;justify-content:end}"];
export { styles as styles };
